export default class BlockQuotes {
	constructor() {

		let blocks = document.querySelectorAll('.block-quotes');

		blocks.forEach((block) => {
			const swiper = block.querySelector('.swiper-quotes');
			const swiperPagination = block.querySelector(".swiper-custom-pagination-fraction");
			const swiperAsset = block.querySelector('.swiper-asset');
			const prev = block.querySelector(".navigation-button-prev");
			const next = block.querySelector(".navigation-button-next");
			const sliderQuotes = new Swiper(swiper, {
				slidesPerView: "1",
				grabCursor: true,
				effect: 'fade',
				speed: 800,
				fadeEffect: {
					crossFade: true
				},
				navigation: {
					prevEl: prev,
					nextEl: next,
				},
				pagination: {
					el: swiperPagination,
					type: 'fraction',
					// C'est ici que la magie opère pour ajouter le "0"
					renderFraction: function (currentClass, totalClass) {
						return '<span class="' + currentClass + '"></span>' +
							' / ' +
							'<span class="' + totalClass + '"></span>';
					},
					// On formate les nombres pour ajouter le zéro si < 10
					formatFractionCurrent: function (number) {
						return number < 10 ? '0' + number : number;
					},
					formatFractionTotal: function (number) {
						return number < 10 ? '0' + number : number;
					}
				}
			});

			const sliderAsset = new Swiper(swiperAsset, {
				slidesPerView: "1",
				grabCursor: false,
				allowTouchMove: false,
				speed: 800,
				effect: 'creative',
				creativeEffect: {
					prev: {
						// will set `translateZ(-400px)` on previous slides
						translate: [0, 0, -50],
						opacity: 0
					},
					next: {
						// will set `translateX(100%)` on next slides
						translate: [0, 0, 50],
						opacity: 0
					},
				}
			});

			sliderQuotes.controller.control = sliderAsset;

		});
	}
}
